const Images={
    Resume: require('./images/SandeepResume.pdf'),
    Rimg1: require('./images/SandeepResume-1.jpg'),
    Rimg2: require('./images/SandeepResume-2.jpg'),
    Rimg3: require('./images/SandeepResume-3.jpg'),
    Rimg4: require('./images/SandeepResume-4.jpg'),
    Rimg5: require('./images/SandeepResume-5.jpg'),
    DataManagement: require('./images/frontend.jpg'),
    Frontend: require('./images/2150062008-1.jpg'),
    Backend: require('./images/3642-1.jpg'),
    Illustration_Frontend: require('./images/freepik__background__61590.png'),
    Partners: {
        Partner_One: require('./images/partner-1.jpg'),
        Partner_Two: require('./images/partner-2.jpg'),
        Partner_Three: require('./images/partner-3.jpg'),
        Partner_four: require('./images/review-5.webp'),
    },
    git_background: require('./images/2150248019.jpg'),
    sandeep_one: require('./images/sandeep_img1.jpg'),
    form_background: require('./images/vadim-shevyrin-xsTDS2URj6c-unsplash.jpg'),

}
export default Images;